import React from 'react';
import moment from "moment";
import {MdTextField} from 'core/components/fields/fields';
import {FIELDDEFDISPLAYTYPE} from 'core/form/form';
import {createForm} from 'core/form/createForm';
import {FormProps} from 'core/form/formUtils';
import StyledSelect from 'core/components/fields/styledSelect';
import NumberField from 'core/components/fields/numberField';
import {BlockComp} from 'core/components/blockComp/blockComp';
import {Validate} from 'core/form/validate';
import {NumberFormat, Min, Pattern, Max} from 'core/form/rules';
import {optionsSearch} from "core/common/service/commonDataService";
import {observer} from "mobx-react";
import {PARTYROLE} from "party/partyDomain";
import StyledDatePicker from "core/components/fields/styledDatePicker";
import {
  ShipmentRepackaging,
  SHIPMENTREPACKAGINGSTATUS_COLORS
} from "shipment/shipmentDomain";
import {grey400} from "material-ui/styles/colors";
import RadioButtonField from "core/components/fields/radioButtonField";
import {TIME_PATTERN_HH_mm} from "core/common/utils/dateUtils";
import {action} from "mobx";
import {LovItem} from "core/metamodel/mdEntity";
import {lovValue} from 'core/form/formUtils';



@createForm({
  formName: 'ShipmentRepackagingForm',
  fields: [{
    name: 'shipmentDate',
    validators: ['IsRequired']
  }, {
    name: 'shipmentTime'
  }, {
    name: 'repackagingStatus',
    validators: ['IsRequired'],
    displayType: FIELDDEFDISPLAYTYPE.radioButton
  },  {
    name: 'comment',
    displayType: FIELDDEFDISPLAYTYPE.textArea
  }, {
    name: 'shippedTo',
    validators: ['IsRequired']
  }, {
    name: 'shippedToAddress',
    validators: ['IsRequired']
  }, {
    name: 'paletteCount',
    validators: ['IsNumber']
  }, {
    name: 'paletteItemCount',
    validators: ['IsNumber']
  }, {
    name: 'product'
  }, {
    name: 'repackagingCode'
  }, {
    name: 'boxQuantity'
  }, {
    name: 'customerNumber'
  }, {
    name: 'packageType',
    validators: ['IsRequired']
  }, {
    name: 'priority',
    validators: ['IsNumber']
  }]
}, () => <noscript/> )
@observer
export default class ShipmentRepackagingForm extends React.Component<FormProps<ShipmentRepackaging, ShipmentRepackaging>, undefined> {


  componentDidMount() {
    let partyId = lovValue(this.props.dataObject.shippedTo);
    return this.populateShippedToAddress(partyId, false);
  }



  componentDidUpdate() {
    let {form, dataObject} = this.props;
    let shippedToAddressField = form.getField("shippedToAddress");
    let partyId = lovValue(dataObject.shippedTo);

    if (shippedToAddressField && partyId && (!shippedToAddressField.props.options || !shippedToAddressField.props.options.length)) {
      console.debug("componentDidUpdate, no dropdown data filling");
      return this.populateShippedToAddress(partyId, false);
    }
  }

  render() {


    let {dataObject, rootObject, entity, entities, form, formName} = this.props;
    let fields = form.fields;
    let {
      shipmentDate, shipmentTime, comment, shippedTo, shippedToAddress, product, repackagingStatus, packageType, customerNumber, repackagingCode, boxQuantity, paletteCount, paletteItemCount, priority
    } = dataObject.getFormFields(formName);


    return (

      <form style={{marginTop: 10}}>

        <BlockComp>
          <div className="row">
            <div className="fx col-xs-6 col-sm-2">
              <StyledDatePicker {...shipmentDate.props}  />
              <Validate field={shipmentDate} value={shipmentDate.props.value}/>
            </div>
            <div className="fx col-xs-6 col-sm-2">
              <MdTextField {...shipmentTime.props} />
              <Validate field={shipmentTime} value={shipmentTime.props.value}>
                <Pattern pattern={TIME_PATTERN_HH_mm}/>
              </Validate>
            </div>

            <div className="col-xs-12 col-sm-7 col-sm-offset-1">
              <div style={{color: grey400, marginBottom: 5}}>{repackagingStatus.mdField.formLabelActive}</div>
              <RadioButtonField {...repackagingStatus.props} groupStyle={{display: 'flex'}}
                                optionStyle={{width: 'initial', marginRight: 15}}
                                labelStyle={{whiteSpace: 'nowrap', marginLeft: -10}}
                                iconStyleFn={v => ({fill: dataObject.getRepackagingStatusIconClass(moment().startOf('day'), v)})}/>
              <Validate field={repackagingStatus} value={repackagingStatus.props.value}/>
            </div>
          </div>

          <div className="row">
            <div className="fx col-xs-6 col-sm-1">
              <NumberField {...priority.props} />
              <Validate field={priority} value={priority.props.value}>
                <NumberFormat precision={1} scale={0}/>
                <Min min={1}/>
                <Max max={9}/>
              </Validate>
            </div>
            <div className="fx col-xs-13 col-sm-11">
              <StyledSelect  {...shippedTo.props} async={true}
                             loadOptions={optionsSearch.bind(this, 'Party', {role: [PARTYROLE.CUSTOMER_ROLE]})}
                             clearable={true}/>
              <Validate field={shippedTo} value={shippedTo.props.value} onSuccess={this.onShippedToSuccess}/>
            </div>
            <div className="fx col-xs-13 col-sm-11">
              <StyledSelect  {...shippedToAddress.props} clearable={false}/>
              <Validate field={shippedToAddress} value={shippedToAddress.props.value} />
            </div>
          </div>


          <div className="row">
            <div className="fx col-xs-12 col-sm-4">
              <StyledSelect {...packageType.props} />
              <Validate field={packageType} value={packageType.props.value} />
            </div>
            <div className="fx col-xs-12 col-sm-4">
                  <StyledSelect  {...product.props} async={true}
                                 loadOptions={optionsSearch.bind(this, 'Product', {})}
                                 clearable={true}/>
                  <Validate field={product} value={product.props.value} />
                </div>
            <div className="fx col-xs-12 col-sm-4">
              <MdTextField {...repackagingCode.props} />
            </div>
            <div className="fx col-xs-12 col-sm-4">
              <MdTextField {...boxQuantity.props} />
            </div>
            <div className="fx col-xs-12 col-sm-4">
              <MdTextField {...customerNumber.props} />
            </div>
          </div>

          <div className="row">
            <div className="fx col-xs-12 col-sm-4">
              <NumberField {...paletteCount.props} />
              <Validate field={paletteCount} value={paletteCount.props.value}>
                <NumberFormat precision={4} scale={0}/>
                <Min min={0}/>
              </Validate>
            </div>
            <div className="fx col-xs-12 col-sm-4">
              <NumberField {...paletteItemCount.props} />
              <Validate field={paletteItemCount} value={paletteItemCount.props.value}>
                <NumberFormat precision={4} scale={0}/>
                <Min min={0}/>
              </Validate>
            </div>
          </div>


          <div className="row">
            <div className="col-xs-12">
              <div className="fx col-xs-12">
                <MdTextField {...comment.props} multiLine={true} rows={4}/>
              </div>
            </div>
          </div>

        </BlockComp>

      </form>

    )
  }

  populateShippedToAddress(partyId: number, reset: boolean): Promise<any> {
    let {dataObject, form} = this.props;

    return ( (partyId != null) ? optionsSearch('Address', {partyId}) : Promise.resolve({options: []}) )
      .then(action("onShippedToChange-cb1", ({options}: {options: LovItem[]}) => {
        form.getField("shippedToAddress").props.options = options;
        if (reset) {
          dataObject.shippedToAddress = (options.length === 1) ? options[0] : null;
          form.updateFieldsPropValue(dataObject, "shippedToAddress");
        }
      }));
  }

  @action onShippedToSuccess = () => {
    let {entities, dataObject, form} = this.props;
    console.log('onShippedToChange ', dataObject.shippedTo);

    let partyId = lovValue(dataObject.shippedTo);

    return this.populateShippedToAddress(partyId, true);
  };
}





// WEBPACK FOOTER //
// ./src/shipment/component/shipmentRepackagingForm.tsx